































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { getAlertColorByPriority, Method } from '../../../core/utils';
import Input from '../../../core/components/Input.vue';
import AlertBox from '../../../core/components/AlertBox.vue';
import SimpleTable from '../../../core/components/SimpleTable.vue';
import { RootStoreHelper } from '../../../core/mixins';

@Component({
    components: {
        AlertBox,
        Input,
        SimpleTable
    }
})
export default class DeleteConfirmation extends Mixins(RootStoreHelper) {
    @Prop({ default: false }) openConfirmation: boolean;
    @Prop({ default: false }) deleteMe: boolean;
    @Prop({
        default() {
            return [];
        }
    })
    summary: Array<object>;
    @Prop() closeConfirmation: Method<boolean, void>;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: 'Aceptar' }) confirmBtnName: string;
    @Prop({ default: 'Eliminar' }) confirmBtnTextDeleteMe: string;
    @Prop({ default: '900px' }) maxWidth: string;
    @Prop({ default: 'Eliminar' }) deleteTitle: string;
    @Prop({ default: 'eliminar' }) confirmationKey: string;
    @Prop({ default: '¿Está seguro que desea eliminar los elementos seleccionados?' }) deleteBody: string;
    deleteMeValue: string = '';

    @Prop({ default: () => [] }) headersTable: any[];
    @Prop({ default: () => [] }) getItems: any[];
    @Prop({ default: false }) isVariableGroupModal: boolean;
    @Prop({ default: true }) visibleWarning: boolean;
    @Prop({ default: null }) selectedItemCountVehicles: number;

    variableGroupDeleteOrDesconfigure: string = 'onlyEliminate';

    selectedItems: any[] = [];
    variableGroupList: any[] = [];
    search: string = '';
    sortBy: string[] = ['name'];
    sortDesc: boolean[] = [false];

    updateSearchValue(value){
        this.search = value;
    }

    getBadgeColor() {
        return getAlertColorByPriority();
    }

    sendDataToParent() {
        let submitedData = {
            desconfigure_vehicles: this.desconfigureVehicles
        };
        this.$emit('submitRadio', submitedData);
    }

    @Watch('openConfirmation')
    observableOpen(value) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    updateDeleteMeValue(value) {
        this.deleteMeValue = value;
    }

    closeAction() {
        this.updateDeleteMeValue('');
        this.closeConfirmation(false);
        this.variableGroupDeleteOrDesconfigure = 'onlyEliminate';
    }

    confirmAction() {
        this.sendDataToParent();
        this.updateDeleteMeValue('');
        this.closeConfirmation(true);
        this.variableGroupDeleteOrDesconfigure = 'onlyEliminate';
    }

    get disabledAccept() {
        if (!this.deleteMe) {
            return this.loading;
        } else {
            if (this.deleteMeValue !== this.confirmationKey) {
                return true;
            } else {
                return false;
            }
        }
    }

    get desconfigureVehicles() {
        return this.variableGroupDeleteOrDesconfigure == 'desconfigureVehicles';
    }
}
